import React from 'react';

export const SPARK_LATEST_COLOR = '#2563EB';
export const SPARK_PRIOR_COLOR = '#9CA3AF';

export interface SparklineProps {
  /** One value per month, oldest first. */
  counts: number[];
  /** Index of the first month in the latest period (those bars are drawn in the accent). */
  latestFrom: number;
  height?: number;
  'aria-label'?: string;
}

/**
 * Twelve tiny bars: prior period grey, latest period blue. Pure SVG so it
 * renders identically in tables, tiles and tests.
 */
export const Sparkline: React.FC<SparklineProps> = ({
  counts,
  latestFrom,
  height = 28,
  'aria-label': ariaLabel = 'Monthly sessions trend',
}) => {
  const barWidth = 4;
  const gap = 2;
  const width = Math.max(barWidth, counts.length * (barWidth + gap) - gap);
  const max = Math.max(1, ...counts);

  return (
    <svg role="img" aria-label={ariaLabel} width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ display: 'block' }}>
      {counts.map((count, index) => {
        const barHeight = count > 0 ? Math.max(2, Math.round((count / max) * height)) : 1;
        return (
          <rect
            key={index}
            x={index * (barWidth + gap)}
            y={height - barHeight}
            width={barWidth}
            height={barHeight}
            rx={1}
            fill={index >= latestFrom ? SPARK_LATEST_COLOR : SPARK_PRIOR_COLOR}
          />
        );
      })}
    </svg>
  );
};
